module.exports = __webpack_public_path__ + "img/be.9e624fe6.svg";